import LoadingWrapper from '@/components/loading-wrapper';
import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';

interface DeactivateDomainDialogProps {
	open: boolean;
	zoneName: string;
	isLoading: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
}

export default function DeactivateDomainDialog({
	open,
	zoneName,
	isLoading,
	onOpenChange,
	onConfirm,
}: DeactivateDomainDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className='sm:max-w-[440px]'>
				<DialogHeader>
					<DialogTitle>Отключить домен?</DialogTitle>
					<DialogDescription>
						Домен <strong>{zoneName}</strong> перестанет обслуживать лендинги. Сайты на нём останутся, но будут
						недоступны до повторного включения.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className='flex-col sm:flex-col'>
					<div className='w-full'>
						<LoadingWrapper show={isLoading}>
							<Button type='button' variant='destructive' className='w-full' disabled={isLoading} onClick={onConfirm}>
								Отключить
							</Button>
						</LoadingWrapper>
					</div>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
